import React from 'react';

export const Badge = ({ children, variant = 'default', className = '' }) => {
  const variants = {
    default: 'bg-slate-800 text-slate-300 border-slate-700',
    cyan: 'bg-cyan-950/50 text-cyan-400 border-cyan-800/50',
    yellow: 'bg-yellow-950/50 text-yellow-400 border-yellow-800/50',
    red: 'bg-red-950/50 text-red-400 border-red-800/50',
    green: 'bg-emerald-950/50 text-emerald-400 border-emerald-800/50',
  };

  return (
    <span className={`px-2 py-0.5 text-xs font-mono rounded-sm border ${variants[variant]} ${className}`}>
      {children}
    </span>
  );
};